import { useEffect, useState } from "react";

const isStandalone = () => window.matchMedia?.("(display-mode: standalone)").matches || window.matchMedia?.("(display-mode: fullscreen)").matches || window.navigator.standalone === true;

/* Écran de lancement affiché uniquement dans l'app installée (PWA), une fois par session */
export function SplashScreen() {
  const [show, setShow] = useState(() => isStandalone() && !sessionStorage.getItem("orbit_splash_done"));
  const [fade, setFade] = useState(false);
  useEffect(() => {
    if (!show) return;
    sessionStorage.setItem("orbit_splash_done", "1");
    const t1 = setTimeout(() => setFade(true), 1400);
    const t2 = setTimeout(() => setShow(false), 1900);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [show]);
  if (!show) return null;
  return (
    <div data-testid="splash-screen" className={`fixed inset-0 z-[5000] flex flex-col items-center justify-center bg-[#f0f5ff] transition-opacity duration-500 ${fade ? "opacity-0" : "opacity-100"}`}>
      <img src="/icon-512.png?v=3" alt="Orbit" className="w-32 h-32 rounded-[28px] shadow-2xl shadow-blue-200 animate-[splashIn_.7s_ease-out]"/>
      <div className="mt-6 font-display text-3xl font-bold tracking-tight text-[#0b1f4d]">Orbit</div>
      <div className="mt-1 text-xs uppercase tracking-[0.25em] text-slate-500">Operational reporting</div>
      <div className="mt-8 h-1 w-24 rounded-full bg-slate-200 overflow-hidden"><div className="h-full w-1/2 bg-blue-600 rounded-full animate-[splashBar_1.4s_ease-in-out_infinite]"/></div>
      <style>{`@keyframes splashIn{from{opacity:0;transform:scale(.8)}to{opacity:1;transform:scale(1)}}@keyframes splashBar{0%{transform:translateX(-100%)}100%{transform:translateX(300%)}}`}</style>
    </div>
  );
}
